<script lang="ts" setup>
import { SubscriptionInfoStore } from '@/services/SubscriptionInfoStore.js';
import { useTranslate } from '@nzyme/vue-i18n/useTranslate.js';
import { useService } from '@nzyme/vue-ioc/useService.js';
import type { ChatSubscriptionStart } from '@sigma/chat-common/ChatEvent.js';
import { defineChatEventProps } from '@sigma/client/chat/defineChatEventProps.js';
import { useChatSubscriptionStart } from '@sigma/client/chat/useChatSubscriptionStart.js';
import ChatEventWrapper from '@sigma/ui/chat/ChatEventWrapper.vue';
import ChatSubscriptionStartCard from '@sigma/ui/chat/ChatSubscriptionStartCard.vue';

import chatCss from './chat.module.scss';
import * as l from './ChatSubscriptionStart.loc.js';

const props = defineProps(defineChatEventProps<ChatSubscriptionStart>());
const t = useTranslate();
const store = useService(SubscriptionInfoStore);
const subscription = useChatSubscriptionStart({
  subscriptionId: () => props.event.subscriptionId,
  load: subscriptionId => store.get(subscriptionId),
});
</script>

<template>
  <ChatEventWrapper
    tid="subscription-start"
    :event="event"
    :class="chatCss.container"
  >
    <ChatSubscriptionStartCard
      :caption="t(l.subscriptionStarted)"
      :title="subscription.title"
      :subtitle="subscription.subtitle"
      :loading="!subscription.loaded"
    />
  </ChatEventWrapper>
</template>
